<template>
  <div class="h-full flex flex-col">
    <div class="flex-1">
        <div :class="['md:w-3/4 md:m-auto md:pb-6', hasKiosk ? 'sticky top-0 z-10' : '']">
        <ProcessBar />
      </div>
      
      <div 
      class="flex flex-col justify-center"
      :style="
        hasKiosk &&
        menu.kiosk_checkout_height &&
        `height:${menu.kiosk_checkout_height}`
      "
      >

      <!-- showTableManual -->

        <Cart v-if="processBarIndex == 1" />

        <TimeSlotSelection v-if="showTimeSlotSelection" />

        <TableManual
        v-if="processBarIndex == 2 && showTableManual == true && showForm == false"
        />

      
          <TableSelection 
            v-if="processBarIndex == 2 && showTable == true && showForm == false"
          />

          <UserDetails 
          v-if="processBarIndex == 2 && showForm"
          />

          <UserDetails
          v-if="processBarIndex == 3 && showPayment == false"
          />

          <Payment v-if="processBarIndex == 3 && showPayment" />

          <Payment v-if="processBarIndex == 2 && showPayment" />

          <Payment v-if="processBarIndex == 4" />


      </div>
    </div>
    <div
      :class="[
        !hasKiosk&&isCickable,
        'sticky bottom-0 pb-4 mt-4 z-50',
        hasKiosk ? 'mt-8' : 'mt-6',
      ]"
      :style="backgroundImage ?  '' : makeStyles(cartSectionTopRadius,paymentFloatBackground)"
    >
      <!-- v-if="processCurrentName != 'Done'" -->

      <!-- Total section sticked to the bottom  -->
      <div v-if="processBarIndex == 1">
        <div
        :class="[
          'mx-auto pt-4 ', hasKiosk ? 'w-2/3' : '', 
          menu.layout == 'frydate' ? 'font-sans' : '']"
      >
        <div
          :class="[
            'mx-2 flex justify-between items-center mr-4',
            hasKiosk ? 'text-lg' : '',
          ]"
        >
          <div
            :style="totalPriceText"
            :class="['text-lg font-bold text-center ']"
          >
            {{ lang["total"][language] }}
          </div>
          <span
            :style="totalPriceColor"
            v-currency="totalPriceValue"
            :class="['text-3xl font-bold text-center']"
          >
          </span>
        </div>
        <div
          :class="['mx-2 flex justify-between pt-4 items-center mr-4']"
          v-show="
            (homeDelivery && homeDeliveryCosts > 0) ||
            (menu.is_disable_takeaway_w_deliv && homeDeliveryCosts > 0)
          "
          :style="processTekst"
          v-if="
            this.minSpent_w_charg_delivery
              ? parseInt(totalPriceValue) + parseInt(tipAmount) <
                this.minSpent_w_charg_delivery
              : true
          "
        >
          <div :class="['text-lg font-bold text-center ']">
            {{ lang["DeliveryCosts"][language] }}
          </div>
          <div
            :class="['font-bold text-center']"
            v-currency="homeDeliveryCosts"
          ></div>
        </div>

        <div class="pb-3">
          <div class="mx-2">
            <div
              v-if="
                parseInt(totalPriceValue) + tipAmount <
                this.menu.min_spent_amount
              "
              :class="['text-left mt-4 mb-4']"
            >
              {{ lang["information"][language] }}{{ currency
              }}{{ this.menu.min_spent_amount
              }}{{ lang["information_extra_extra"][language] }}
            </div>
            <div
              v-show="homeDelivery"
              v-if="
                parseInt(totalPriceValue) + parseInt(tipAmount) <
                this.minSpent_w_charg_delivery
              "
              :class="['text-left mt-4 mb-4']"
            >
              {{ lang["information_delivery"][language] }}{{ currency
              }}{{ this.minSpent_w_charg_delivery }}
            </div>
            <div
              v-if="
                parseInt(totalPriceValue) + tipAmount <
                this.menu.min_spent_amount_delivery
              "
              :class="['text-left mt-4 mb-4']"
            >
              {{ lang["information"][language] }}{{ currency
              }}{{ this.menu.min_spent_amount_delivery
              }}{{ lang["information_extra_extra"][language] }}
            </div>

            <discounts v-if="this.menu.is_discounts_enabled" />

            <div
              v-show="this.menu.enable_tipping"
              :class="['flex justify-between items-center mt-2']"
            >
              <div
                :class="[
                  'font-bold text-lg w-2/3',
                  'text-new-primary' /* theme.body.textColor*/,
                ]"
                :style="text"
              >
                {{ lang["tip"][language] }}
              </div>
              <div :class="['font-bold text-center flex justify-end w-full ']">
                <div
                  :class="[
                    'flex flex-row h-8 rounded-xl relative  bg-white justify-center items-center border-2 w-3/5',
                    /* theme.addToCart.backgroundColorPlus, */
                  ]"
                  :style="cartProcessItemRadius"
                >
                  <button
                    @click="removeFromTipAmount()"
                    :class="[
                      ,
                      /* theme.addToCart.backgroundColorPlus */ 'fill-current focus:outline-none inline-block font-bold rounded-full m-2 ',
                      hasKiosk ? 'w-16' : 'w-12',
                    ]"
                    :style="hasKiosk&&addButtonRadius"
                  >
                    <IconMinus stroke="#666666" />
                  </button>
                  <input
                    type="number"
                    readonly
                    :class="[
                      'focus:outline-none text-center h-6 w-6 text-md md:text-basecursor-default flex items-center outline-none w-full justify-center',
                    ]"
                    name="tip"
                    :value="this.tipAmount"
                  />
                  <button
                    @click="addToTipAmount()"
                    :class="[
                      /* theme.addToCart.backgroundColorPlus, */
                      'font-bold rounded-full cursor-pointer focus:outline-none m-2',
                      hasKiosk ? 'w-16' : 'w-12',
                    ]"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        fill="none"
                        stroke="#666666"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              v-show="
                totalPriceValue + tipAmount < this.menu.min_spent_amount_w_charg
              "
              :class="['flex justify-between pt-4 items-center']"
            ></div>
          </div>
        </div>
      </div>
      </div>
      <div
        v-if="
          parseInt(totalPriceValue) + parseInt(tipAmount) <
            this.menu.min_spent_amount_w_charg && processBarIndex == 1
        "
        :class="[
          'flex mt-2 pb-2 items-center justify-center text-xs text-product-gray',
        ]"
      >
        <div :class="['text-center']">
          <h1 class="">
            {{ lang["Fee_Payment"][language] }}
            <span
              v-if="!discountAmount"
              v-currency="priceToPayBeforeFeeIsGone"
              class="font-bold"
            ></span>
            <span
              v-else
              v-currency="priceToPayBeforeFeeIsGone - discountAmount"
              class="font-bold"
            ></span>
            {{ lang["No_Fee_Payment"][language] }}
            <span v-currency="this.menu.charge_amount_when_min_spent"></span>
          </h1>
        </div>
      </div>
      <FloatingCartInfo class="cursor-pointer" />
    </div>
    <!-- <div
      v-if="totalPriceValueWithCostsValue < this.menu.min_spent_amount"
      :class="['text-left mt-4', theme.body.textColor]"
    >
      {{ lang["information"][language] }}{{ currency
      }}{{ this.menu.min_spent_amount
      }}{{ lang["information_extra_extra"][language] }}
    </div> -->
  </div>
</template>

<script>
import TimeSlotSelection from "../views/TimeSlotSelection";
import FloatingCartInfo from "../components/FloatingCartInfo";
import Payment from "../views/Payment";
import TableSelection from "../views/TableSelection";
import UserDetails from "../views/UserDetails";
import Cart from "../views/Cart";
import ProcessBar from "../views/ProcessBar";
import TableManual from "../views/TableManual";
import { mapGetters, mapState } from "vuex";
import Discounts from "../components/Discounts/Discounts.vue";
import IconMinus from "../components/icons/iconMinus.vue";
import lang from "../lang";
export default {
  data() {
    return {
      lang: lang,
      languageStorage: localStorage.getItem("language"),
    };
  },
  props: ["test"],
  components: {
    TimeSlotSelection,
    FloatingCartInfo,
    Payment,
    TableSelection,
    UserDetails,
    Cart,
    ProcessBar,
    TableManual,
    Discounts,
    IconMinus,
    // lang,
  },
  watch: {
    /**
     * This is custom fix that's been made to fix the scroll position to
     * always top while switching between the steps.
     * this may break if multiple containers get added in modal in future.
     * @see https://www.npmjs.com/package/vue-js-modal
     */
    processBarIndex() {
      let el = document.querySelector("#cart-items-id>div.vm--modal")
      if (el) {
        el.scrollTop = 0;
      }
    },
  },
  computed: {
    ...mapGetters([
      "isSwipeOpen",
      "processBarIndex",
      "processCurrentName",
      "showTable",
      "processBarCurrentItem",
      "showPayment",
      "showForm",
      "processCurrentName",
      "processStack",
      "language",
      "theme",
      "hasKiosk",
      "menu",
      "currency",
      "isCickable",
      "isIOSChrome",
      "isSafari",
      "showTableManual",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "totalPriceValueWithCosts",
      "totalPriceValue",
      "tipAmount",
      "totalPriceValueWithCostsValue",
      "selectedTimeSlot",
      "priceToPayBeforeFeeIsGone",
      "homeDeliveryCosts",
      "homeDelivery",
      "discountAmount",
      "minSpent_w_charg_delivery",
    ]),
    ...mapState(["languageLocales"]),
    ...mapGetters("Theme", [
      "text",
      "goBackButton",
      "goBackButtonText",
      "totalPriceText",
      "totalPriceColor",
      "processTekst",
      "cartProcessItemRadius",
      "addButtonRadius",
      "cartShadowColor",
      "mainSubCategorysBackground",
      "backgroundImage",
      "cartBackground",
      "cartSectionTopRadius",
      "paymentFloatBackground",
    ]),
    showTimeSlotSelection() {
      return this.processBarIndex == 2 &&
          this.showTable == false &&
          this.showPayment == false &&
          this.showForm == false &&
          this.showTableManual == false

    }
  },
  updated() {
    //calculates the feePrice
    let first = this.menu.min_spent_amount_w_charg;
    let charge = this.menu.charge_amount_when_min_spent;
    let delivery = 0;
    let totalPriceValueWithCosts = this.totalPriceValueWithCosts;
    if (
      this.menu.enable_delivery &&
      this.homeDelivery &&
      localStorage.getItem("currentOption") != "take_away"
    ) {
      delivery = this.homeDeliveryCosts;
    }

    let feePrice = first - (totalPriceValueWithCosts - charge - delivery);
    this.$store.commit(
      "Cart/updatePriceToPayBeforeFeeIsGone",
      feePrice.toFixed(2)
    );

    // Adds shadow at the bottom of cart 
    if (this.processBarIndex === 1 && this.hasKiosk) {
      document.getElementById("topShadow").style["boxShadow"] = "0px -20px 50px 45px";
    }
  },
  mounted() {
    // Adds shadow at the bottom of cart 
    if (this.processBarIndex === 1 && this.hasKiosk) {
      document.getElementById("topShadow").style["boxShadow"] = "0px -20px 50px 45px";
    }
  },
  methods: {
    // add or remove tip amount
    removeFromTipAmount() {
      this.$store.commit("Cart/updateTipAmount", -1);
    },
    addToTipAmount() {
      this.$store.commit("Cart/updateTipAmount", 1);
    },
  },
};
</script>

<style>
</style>
